module.exports = __webpack_public_path__ + "static/media/machineTransparentBG.534d8f6c.png";